import { customAmplitude } from '@/utils/customAmplitude'
import {
  buildPremiumPromptProperties,
  buildSignupAnalyticsContext,
} from '@/utils/signupPremiumAnalytics'

export const AI_MODELS_SOURCE = 'BtSubscriptionAIModels'
export const AI_MODELS_HD_SOURCE = 'BtSubscriptionAIModelsHD'
export const AI_EDIT_USAGE_LIMIT_REASON = 'Usage limit reached'

export function buildAIModelsPremiumPromptProperties(pathname?: string, source: string = AI_MODELS_SOURCE) {
  return buildPremiumPromptProperties(
    buildSignupAnalyticsContext({
      source,
      type: 'Standard',
      pathname,
    }),
  )
}

export function emitAIModelsUsageLimitReached(): void {
  customAmplitude('AI Edit Error', {
    Type: 'AI_models',
    Reason: AI_EDIT_USAGE_LIMIT_REASON,
  })
}
